export default __webpack_public_path__ + "media/PROFILEANALYSIS.620183a05bf9c5d45fdd991d0c26df12.mp4";